import { Paging } from 'Feature/Arrears/components/ArrearsInquiryPage/core/Paging';

export type ApiPagedSuccessResponse<T> = {
  data: T[];
  page: ApiPageResponse;
};

export type ApiSuccessResponse<T> = {
  data: T;
};

export type ApiErrorResponse<T> = {
  errors: { code: T }[];
};

export type ApiPageResponse = {
  totalRecordCount: number;
  take: number;
  skip: number;
};

export const toPaging = (page: ApiPageResponse): Paging => ({
  total: page.totalRecordCount,
  take: page.take,
  skip: page.skip
});
